export default __webpack_public_path__ + "23605ed375c7fc805012dd7e15adf501.png";